import React, { Component } from "react";
import { connect } from "react-redux";
import { changeSwModeAction, changeRegModeAction } from "../../redux/app/actions";
import { openSwAction } from "../../redux/ui/actions";
import { initDsAction, addDsAction, changeDsAction, delDsAction, changeSelRowAction, isDelAction } from "../../redux/geo/actions";
import Sw from "../common/Sw";
import Table from "../common/Table";
import Main from "./Main";
import jschardet from "jschardet";

const mapStateToProps = (state) => {
    return {
        swMode: state.appReducer.swMode,
        regMode: state.appReducer.regMode,
        ds: state.geoReducer.dataset,
        selRow: state.geoReducer.selRow,
        isDel: state.geoReducer.isDel,
        focusSwCat: state.uiReducer.focusSwCat,
    };
};

const tData = [
    { ID: "ID", text: "ID", class: "tsS", abbre: null },
    { ID: "name", text: "名称", class: null, abbre: 50 },
];

class List extends Component {
    constructor(props) {
        super(props);
        this.openSw = this.openSw.bind(this);
        this.closeSw = this.closeSw.bind(this);
        this.delDs = this.delDs.bind(this);
        this.copyDs = this.copyDs.bind(this);

        this.props.dispatch(changeSelRowAction(null));
    }

    async loadGeoDs() {
        const origin = window.location.origin;
        const search = window.location.search;
        fetch(`${origin}/api/geoInfo/datasets/${search}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((res) => {
                console.log(res);
            })
            .catch((err) => {
                console.log(err);
                alert("サーバーエラー");
            });
    }
    componentDidUpdate(prevProps) {
        /*
         * 削除時データセットIDを修正
         * @since hara 2020-10-14
         */
        if (this.props.isDel) {
            const ds = [...this.props.ds];
            ds.forEach((el, index) => {
                el.ID = index + 1;
            });

            this.props.dispatch(changeDsAction(ds));
            this.props.dispatch(isDelAction(false));
        }
    }

    /*
     * サブウィンドウを開く
     * @param {Number} mode 0=新規/1=編集
     * @since hara 2020-10-05
     */
    openSw(mode) {
        if (mode === 1 && this.props.selRow === null) return; //編集で行未選択の場合

        this.props.dispatch(openSwAction("geoInfoMain"));
        this.props.dispatch(changeRegModeAction(mode));
    }

    /*
     * サブウィンドウを閉じる
     * @since hara 2020-09-09
     */
    closeSw() {
        this.props.dispatch(openSwAction(null));
        this.props.dispatch(changeSwModeAction(0));
    }

    /*
     * データセット削除
     * @since hara 2020-10-14
     */
    delDs() {
        if (this.props.selRow === 0) {
            alert("既存データセットは削除できません。");
        } else if (this.props.selRow !== null) {
            const answer = window.confirm("選択したデータセットを削除してもよろしいですか。");
            if (answer) {
                const origin = window.location.origin;
                const search = window.location.search;
                fetch(`${origin}/api/geoInfo/delDs/${search}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        data: this.props.ds[this.props.selRow],
                    }),
                })
                    .then((res) => res.json())
                    .then((res) => {
                        console.log(res);
                        this.props.dispatch(initDsAction(res));
                    })
                    .catch((err) => {
                        console.log(err);
                        alert("サーバーエラー");
                    });
            }
        }
    }

    /*
     * データセットコピー
     * @since hara 2020-11-05
     */
    copyDs() {
        if (this.props.selRow !== null) {
            const ds = [...this.props.ds];
            const index = this.props.selRow;
            const copyDs = Object.create(ds[index]);
            copyDs.ID = ds.length + 1;

            this.props.dispatch(addDsAction(copyDs));
        }
    }

    /*
     * ファイルインポート
     * @since sangenya 2024-09-06
     */
    async fileImport() {
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.onchange = (event) => {
            const file = event.target.files[0];
            if (!file) {
                return;
            }

            const fileSizeInBytes = file.size;
            const fileSizeInMB = fileSizeInBytes / (1024 * 1024); // バイトをMBに変換

            if (fileSizeInMB > 5) {
                alert("5MB以上のファイルはアップロードできません。");
                return;
            } else {
                const reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onload = (event) => {
                    const arrayBuffer = event.target.result;
                    const byteArray = new Uint8Array(arrayBuffer);

                    // Uint8Array を Buffer に変換
                    const buffer = Buffer.from(byteArray);

                    // jschardet でエンコーディングを判定（Buffer を渡す）
                    const detected = jschardet.detect(buffer);
                    // エンコーディングを判定後、必要に応じて処理
                    let encoding = detected.encoding ? detected.encoding : "utf-8";
                    if (["ISO-8859-2", "ISO-8859-1", "windows-1252", "EUC-JP", "ISO-2022-JP", "CP932"].includes(encoding)) {
                        encoding = "shift-jis"; // これらの場合、Shift-JIS に切り替える
                    }
                    const decoder = new TextDecoder(encoding);
                    const contents = decoder.decode(new Uint8Array(arrayBuffer));
                    const fileName = file.name; // ファイル名を取得
                    const origin = window.location.origin;
                    const search = window.location.search;
                    fetch(`${origin}/api/geoInfo/load/${search}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            file: contents,
                            fileName: fileName,
                        }),
                    })
                        .then((res) => res.json())
                        .then((res) => {
                            if (res.exist) {
                                alert("同名のファイルはインポートできません。");
                                this.waiting(false);
                            } else {
                                console.log(res);
                                this.props.dispatch(initDsAction(res));
                                console.log("send file");
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            alert("サーバーエラー");
                        });
                    // // ファイルの内容を処理する
                    // //サーバーにファイルの内容を送信
                };
                const a = 1;
                const ua = window.navigator.userAgent.toLowerCase();
                /*
                if (ua.indexOf("windows nt") !== -1) {//windowsの場合shift-jisで読み込む
                    reader.readAsText(file, 'Shift_JIS');
                    console.log('ファイルはShift_JISとして読み込まれました。');
                } else {
                    reader.readAsText(file);
                    console.log('ファイルはUTF-8として読み込まれました。');
                }
                */
            }
        };
        fileInput.click();
    }

    render() {
        return (
            <Sw title="地質情報" focusName="geoInfo">
                <div className="l-flex">
                    {/*
                    <button className='sBtn' onClick={() => this.openSw(0)}>新規</button>
                    */}
                    <button className="sBtn l-mlS" onClick={() => this.openSw(1)}>
                        修正
                    </button>
                    <button className="sBtn l-mlS" onClick={this.delDs.bind(this)}>
                        削除
                    </button>
                    <button className="sBtn l-mlS" onClick={this.fileImport.bind(this)}>
                        インポート
                    </button>
                    {/*
                    <button className='sBtn l-mlS' onClick={this.copyDs}>コピー</button>
                      */}
                </div>

                <Table class="TWrap l-mtS" tData={tData} ds={this.props.ds} action={changeSelRowAction} isDel={this.props.isDel} selRow={this.props.selRow} />

                <div className="l-right l-mtM">
                    <button className="cBtn" onClick={this.closeSw}>
                        閉じる
                    </button>
                </div>
            </Sw>
        );
    }
}
export default connect(mapStateToProps)(List);
